import React, { Component } from 'react';

import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import { connect } from 'react-redux';
import { UPDATE_INFO } from '../actions/actionTypes';
import PrivateRouter from './PrivateRouter';
import OtpInput from 'react-otp-input';
import { toastr } from 'react-redux-toastr';
import { reactLocalStorage } from 'reactjs-localstorage';
import { imagePath } from '../actions/ImagePath';
import GBLVAR from "../Global Variables/GlobalVariables";
import {Countries} from "../Components/Countries";
import ApiGateway from "../DataServices/DataServices";  
import directCancel from '../Components/directCancel';
import directSuccess from '../Components/directSuccess';



const Header = React.lazy(() => import('../Components/Header'));
const Footer = React.lazy(() => import('../Components/Footer'));
const Home = React.lazy(() => import('../Components/Home'));
const MerchantScreen = React.lazy(() => import('../Components/MerchantScreen'));
const ProductView = React.lazy(() => import('../Components/ProductView'));
const ViewCart = React.lazy(() => import('../Components/ViewCart'));
const Checkout = React.lazy(() => import('../Components/Checkout'));
const Thanks = React.lazy(() => import('../Components/Thanks'));
const MyAccount = React.lazy(() => import('../Components/MyAccount'));
const ViewOrder = React.lazy(() => import('../Components/ViewOrder'));
const Category = React.lazy(() => import('../Components/Category'));
// const Payment = React.lazy(() => import('../Components/Payment'));
const General = React.lazy(() => import('../Components/General'));
const Games = React.lazy(() => import('../Components/Games'));
const DetailPage = React.lazy(() => import('../Components/DetailPage'));
const ProductFoloosiView = React.lazy(() => import('../Components/ProductFoloosiView'));
const Success = React.lazy(() => import('../Components/Success'));
const Cancel = React.lazy(() => import('../Components/Cancel'));

var style = {
  showCloseButton: false,
  timeOut: 2000
}

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
    }
  }
  componentDidMount(){
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
		var self = this;
		reactLocalStorage.setObject("cartItems", self.props.state.cartItems);
		reactLocalStorage.set("subTotal", self.props.state.subTotal);
    reactLocalStorage.setObject("vat_tax", self.props.state.vat_tax);  
    reactLocalStorage.setObject("additional_product_fees", self.props.state.additional_product_fees);  
    reactLocalStorage.set("shipping_fee", self.props.state.shipping_fee); 
    reactLocalStorage.set("merchant_id", self.props.state.merchant_id); 
    reactLocalStorage.set("send_merchant_id", self.props.state.send_merchant_id); 
    reactLocalStorage.set("Total", self.props.state.Total);
    reactLocalStorage.set("voucher_transaction", self.props.state.voucher_transaction);
    reactLocalStorage.set("voucher_transaction_type", self.props.state.voucher_transaction_type);
    reactLocalStorage.setObject("recharge_data", self.props.state.recharge_data);
  } 
  render() {
    return (
      <React.Suspense fallback={
        <div className="loading_wrap">
            <div className="loading_fix">
              <img src={imagePath("./loader.gif").default} />
              <div className="loading_con">Loading...</div>
              <div className="cpy_con">Powered by Foloosi</div>
            </div>
        </div>
      }>        
        {(this.props.location.pathname.split('/')[1] !== "payment") ? <Header location={this.props.location} 
        history={this.props.history} match={this.props.match} /> : null}
        <Switch>          
          <Route exact={true} path="/" component={MerchantScreen} /> 
          <Route exact={true} path="/categories/:category_id" component={MerchantScreen} /> 
          <Route exact={true} path="/:merchant_id" component={Home} />  
          <Route exact={true} path="/product-view/:product_id" component={ProductView} />
          <PrivateRouter exact={true} path="/order/view-cart" component={ViewCart} />  
          <PrivateRouter exact={true} path="/order/checkout" component={Checkout} /> 
          <Route exact={true} path="/order/thanks" component={Thanks} />  
          <Route exact={true} path={GBLVAR.PAGE_NAME.directSuccess} component={directSuccess} />  
          <Route exact={true} path={GBLVAR.PAGE_NAME.directCancel} component={directCancel} />  
          <Route exact={true} path={GBLVAR.PAGE_NAME.Success} component={Success} />  
          <Route exact={true} path={GBLVAR.PAGE_NAME.Cancel}component={Cancel} />  
          <PrivateRouter exact={true} path="/customer/myaccount" component={MyAccount} />   
          <PrivateRouter exact={true} path="/vieworder/:order_id" component={ViewOrder} /> 
          <Route exact={true} path="/category-productlist/:merchant_id/:seo_name" component={Home} />  
          <Route exact={true} path="/featured-productlist/:merchant_id" component={Home} />  
          <Route exact={true} path="/productlist/:merchant_id" component={Home} />  
          <Route exact={true} path="/product/category" component={Category} />
          <Route exact={true} path="/general/products" component={General} />
          <Route exact={true} path="/games/products" component={Games} />
          <Route exact={true} path="/list-product/:service_id" component={DetailPage} />          
          <Route exact={true} path="/voucher-view/:product_id" component={ProductFoloosiView} />
          {/* <PrivateRouter exact={true} path="/payment/:order_id" component={Payment} />  */}
        </Switch>  
        {(this.props.location.pathname.split('/')[1] !== "payment") ? <Footer/> : null}
        
      </React.Suspense>
    )
  }
}

const mapStateToProps = state => {
  return {
    state: state.AppReducer
  }
};

const mapDispatchToProps = dispatch => ({
  update_store: (payload) => { dispatch({ type: UPDATE_INFO, payload }); return Promise.resolve(); },
})

export default connect(mapStateToProps, mapDispatchToProps)(App);

